import {useSales} from "../../../hooks";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import Select from "react-select";

const SaleSelect = ({customerId, setSale,...props}) => {
    const { t } = useTranslation(["order"]);
    const { data: sales, refetch: refetchSales } =
        useSales({
            customerId: customerId
        });
    useEffect(() => {
        if (customerId) {
            refetchSales();
        }
    }, [customerId])
    const options = []
    for (const key in sales.data.items) {
        options.push({
            label: sales.data.items[key]["display_name"],
            value: sales.data.items[key]["id"]
        })
    }
    if (props.value && !props.value.label) {
        props.value.label = options.find(e => e.value === props.value.value)?.label
    } else if (!props.value && options.length > 0) {
        props.value = {label: ''};
        props.value.label = options[0]?.label;
        setSale('sale_id', options[0], {shouldValidate: true});
    }
    return <Select
        {...props}
        placeholder={t("placeholder.select", {
            title: t("form.sale_id"),
        })}
        options={options}
        classNamePrefix="select2-selection"
    />
}
export default SaleSelect;
